module.exports = __webpack_public_path__ + "img/dd-logo-cjdr.2444724f.png";